import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
export interface MyProfileUser {
  id: number;
  username: string;
  type: string | number;
  user_type: 'candidate' | 'admin' | 'company';
  company_id?: number | null;
  doctor_id?: number | null;
  first_name: string;
  last_name: string;
  phone?: string | null;
  instagram_link?: string | null;
  facebook_link?: string | null;
  tiktok_link?: string | null;
  image?: string | null;
  photo_url?: string | null;
  access_pages?: string[];
  has_access_to_phone_numbers?: boolean;
    user_cv?: string | null;
  user_cv_url?: string | null;

  company?: any;
  doctor?: any;
}

@Injectable({
  providedIn: 'root',
})
export class ResigteringService {
  constructor(private _HttpClient: HttpClient) {}

  user_Resigter(Data: any): Observable<any> {
    return this._HttpClient.post(`${environment.Server_URL}/register`, Data);
  }
  editUser(id:any,Data: any): Observable<any> {
    return this._HttpClient.post(`${environment.Server_URL}/update/user/${id}`, Data);
  }
  getUserById(userId: number | string): Observable<MyProfileUser> {
    return this._HttpClient.get<MyProfileUser>(`${environment.Server_URL}/show/user/${userId}`);
  }

  setToken(token: string): void {
    localStorage.setItem('token', token);
  }
  getUserId():Observable<any>{
    return this._HttpClient.get(environment.Server_URL+'/get-id-user');
  }
  getToken(): string | null {
    return localStorage.getItem('token');
  }
uploadUserCvWithoutToken(userId: number | string, file: File): Observable<any> {
  const formData = new FormData();
  formData.append('user_cv', file);

  return this._HttpClient.post(
    `${environment.Server_URL}/users/${userId}/upload-cv`,
    formData
  );
}
}
